"use strict";
/**
 * Market List Rendering
 * Handles rendering lists of markets and events
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMarketsList = renderMarketsList;
exports.renderEnhancedMarketsList = renderEnhancedMarketsList;
exports.renderEnhancedEventsList = renderEnhancedEventsList;
exports.displayMarketsTable = displayMarketsTable;
/**
 * Escape HTML to prevent XSS
 */
function escapeHtml(text) {
    const map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
    };
    return text.replace(/[&<>"']/g, (char) => map[char]);
}
/**
 * Update market list display (basic version)
 */
function renderMarketsList(markets) {
    const listContainer = document.getElementById("events-list");
    if (!listContainer)
        return;
    listContainer.innerHTML = "";
    markets.forEach((market) => {
        const item = document.createElement("div");
        item.className = "market-item";
        item.dataset.marketId = market.id;
        item.innerHTML = `
      <div class="market-header">
        <div class="market-title">${escapeHtml(market.title)}</div>
        <div class="market-status">${escapeHtml(market.status)}</div>
      </div>
      <div class="market-subtitle">${escapeHtml(market.subtitle)}</div>
      <div class="market-spread">
        <span>Bid: ${market.bid.toFixed(2)}</span>
        <span>Ask: ${market.ask.toFixed(2)}</span>
      </div>
    `;
        listContainer.appendChild(item);
    });
}
/**
 * Update market list with enhanced display
 */
function renderEnhancedMarketsList(markets) {
    const listContainer = document.getElementById("events-list");
    if (!listContainer)
        return;
    listContainer.innerHTML = "";
    markets.forEach((market) => {
        const item = document.createElement("div");
        item.className = "market-item";
        item.dataset.marketId = market.id;
        const midPrice = (market.bid + market.ask) / 2;
        const spread = market.ask - market.bid;
        item.innerHTML = `
      <div class="market-header">
        <div class="market-title">${escapeHtml(market.title)}</div>
        <div class="market-price">$${midPrice.toFixed(4)}</div>
      </div>
      <div class="market-subtitle">${escapeHtml(market.subtitle)}</div>
      <div class="market-details">
        <div class="market-bid-ask">
          <span class="bid">Bid: $${market.bid.toFixed(4)}</span>
          <span class="ask">Ask: $${market.ask.toFixed(4)}</span>
        </div>
        <div class="market-spread">Spread: $${spread.toFixed(4)}</div>
      </div>
      <div class="market-status-badge">${escapeHtml(market.status)}</div>
    `;
        listContainer.appendChild(item);
    });
}
/**
 * Render events with enhanced display
 */
function renderEnhancedEventsList(events) {
    const listContainer = document.getElementById("events-list");
    if (!listContainer)
        return;
    listContainer.innerHTML = "";
    events.forEach((event) => {
        const item = document.createElement("div");
        item.className = "event-item";
        item.dataset.eventId = event.id;
        const category = event.category || "Unknown";
        // Format the scheduled date if available
        let dateDisplay = "";
        if (event.scheduledDate) {
            try {
                const date = new Date(event.scheduledDate);
                dateDisplay = date.toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                });
            }
            catch {
                dateDisplay = event.scheduledDate;
            }
        }
        item.innerHTML = `
      <div class="event-header">
        <div class="event-title">${escapeHtml(event.title)}</div>
        <div class="event-category">${escapeHtml(category)}</div>
      </div>
      ${dateDisplay ? `<div class="event-date">${escapeHtml(dateDisplay)}</div>` : ""}
      <div class="event-details">
        <div class="event-id">
          <span class="label">ID:</span>
          <span class="value">${escapeHtml(event.id)} - ${escapeHtml(event.subtitle)}</span>
        </div>
      </div>
    `;
        listContainer.appendChild(item);
    });
}
/**
 * Display multiple markets in a table format
 */
function displayMarketsTable(markets) {
    const tableContainer = document.getElementById("markets-table");
    if (!tableContainer)
        return;
    const table = document.createElement("table");
    table.className = "markets-table";
    // Header
    const header = table.createTHead();
    const headerRow = header.insertRow();
    headerRow.innerHTML = `
    <th>Market</th>
    <th>Bid</th>
    <th>Ask</th>
    <th>Status</th>
  `;
    // Body
    const tbody = table.createTBody();
    markets.forEach((market) => {
        const row = tbody.insertRow();
        row.innerHTML = `
      <td>${escapeHtml(market.title)}</td>
      <td>$${market.bid.toFixed(4)}</td>
      <td>$${market.ask.toFixed(4)}</td>
      <td>${escapeHtml(market.status)}</td>
    `;
    });
    tableContainer.innerHTML = "";
    tableContainer.appendChild(table);
}
